import { defineStore } from 'pinia'
import { getWalletProducts, getLimitProduct } from '@/service/wallet'

const LIMIT_EXPIRE_AT_KEY = 'limit_offer_expire_at_ms'

export const useWalletStore = defineStore('wallet', {
  // state中定义数据
  state: () => ({
    productList: null,
    limitProduct: null,
    limitExpireAtMs: Number(localStorage.getItem(LIMIT_EXPIRE_AT_KEY) || 0)
  }),
  // 2. 计算属性
  getters: {
    vipWeekItem: (state) => {
      if (state.productList == null) {
        return null
      }
      return state.productList.find(item => item.id === 'vip_7days') || state.productList[0]
    }
  },
  // 3. 修改数据的方法
  actions: {
    async initProduct() {
      logger.debug('initProduct')

      let productResult = null
      try {
        productResult = await getWalletProducts()
      } catch (error) {
        logger.debug(error)
      }
      if (productResult) {
        logger.debug('initProduct productResult = ', productResult)
        this.productList = productResult.products
        localStorage.removeItem('product_list')
      }
    },
    async initLimitProduct() {
      let result = null
      try {
        result = await getLimitProduct()
      } catch (error) {
        logger.debug(error)
      }
      this.limitProduct = result?.product || null
      return this.limitProduct
    },
    /**
     * 全局倒计时：
     * - 如果已有有效倒计时：沿用
     * - 如果没有：随机生成 [0.5*valid_time, valid_time] 秒
     */
    ensureLimitCountdown() {
      const product = this.limitProduct
      const validSec = Number(product?.valid_time || 0)
      if (!product || validSec <= 0) {
        this.limitExpireAtMs = 0
        localStorage.removeItem(LIMIT_EXPIRE_AT_KEY)
        return 0
      }

      const now = Date.now()
      if (this.limitExpireAtMs > now) {
        return this.limitExpireAtMs
      }

      const minSec = Math.max(1, Math.ceil(validSec * 0.5))
      const maxSec = Math.max(minSec, Math.floor(validSec))
      const randomSec = Math.floor(Math.random() * (maxSec - minSec + 1)) + minSec
      const expireAt = now + randomSec * 1000
      this.limitExpireAtMs = expireAt
      localStorage.setItem(LIMIT_EXPIRE_AT_KEY, String(expireAt))
      return expireAt
    }
  }
})
